import { IconButton, Label } from 'src/components'
import { classes } from 'src/utils'
import { DuplicateIcon } from '@heroicons/react/solid'
import { useCallback, useMemo } from 'react'
import { toast } from 'sonner'
import { cn } from 'src/ui/lib/utils'

type Props = {
  classNameInput?: string
  className?: string
  classNameCopyIcon?: string
  value: string
  onChange?: (value: string) => void
  enabledCopy?: boolean
  label?: string
  error?: boolean
  disabled?: boolean
}
export function TextareaField(props: Props) {
  const copy = useCallback(() => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(props.value).then(() => {
        toast.success(`Copied to clipboard.`)
      })
    }
  }, [props.value])

  const textareaClassName = useMemo(
    () =>
      classes(
        'outline-none border p-4 block text-xs w-full resize-none rounded bg-slate-100',
        props.error
          ? 'text-red-500 focus-within:border-red-500 focus-within:ring-red-500 focus-within:ring-1 hover:shadow-sm hover:border-slate-200 hover:focus-within:border-red-500'
          : 'text-slate-600 focus-within:border-theme-500 focus-within:ring-theme-500 focus-within:ring-1 hover:shadow-sm hover:border-slate-200 hover:focus-within:border-theme-500',
        props.classNameInput,
      ),
    [props.error, props.classNameInput],
  )

  return (
    <div className={classes('group w-full', props.className)}>
      {props.label ? (
        <Label className="block group-hover:text-slate-500 group-focus-within:text-theme-500 group-hover:group-focus-within:text-theme-500 mb-1 lowercase">
          {props.label}
        </Label>
      ) : null}
      <div className="relative w-full">
        {props.enabledCopy && props.value.trim() ? (
          <IconButton
            onClick={copy}
            className={classes(
              'absolute right-2 top-2 group-hover:block hidden bg-slate-100',
              props.classNameCopyIcon,
            )}
            icon={<DuplicateIcon className="fill-theme-500 hover:opacity-80" />}
          />
        ) : null}

        <textarea
          disabled={props.disabled}
          onChange={(event) =>
            props.onChange && props.onChange(event.target.value)
          }
          value={props.value}
          className={cn(textareaClassName, props.classNameInput)}
        />
      </div>
    </div>
  )
}
